<template>
  <app-launcher-update
    :version="update.target"
    :pending="update.pending"
    :complete="update.complete"
    :reports="update.reports"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue-demi';

import AppLauncherUpdate from '../components/AppLauncherUpdate.vue';
import { useAppLauncher } from '../composables';

export default defineComponent({
  name: 'AppLauncherUpdateContainer',
  components: { AppLauncherUpdate },
  setup() {
    const { update } = useAppLauncher();
    return { update };
  },
});
</script>
